__turbopack_context__.v({
  "error": "TextArea-module-scss-module__ZlzLzW__error",
  "floating-label": "TextArea-module-scss-module__ZlzLzW__floating-label",
  "textbox-answer-input": "TextArea-module-scss-module__ZlzLzW__textbox-answer-input",
});
